import Button from '@eversports/react-components/primitives/Button'
import Flex from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import TextField from '@eversports/react-components/primitives/TextField'
import { InputAdornment } from '@mui/material'
import PyroForm, { Form } from 'pyro-form'
import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  onApplyVoucher: (voucher: string) => void
  loading: boolean
}

interface InitialValues {
  voucher: string
}

function handleValidate(values: InitialValues) {
  // TODO: Migrate to core-io validation
  const errors: Partial<InitialValues> = {}

  if (values.voucher.length === 0) {
    errors.voucher = (<Localized id="please-enter-a-voucher" />) as any
  }
  return errors
}

const initialValues: InitialValues = { voucher: '' }

const VoucherSelectionActive: React.FC<React.PropsWithChildren<Props>> = ({
  onApplyVoucher: handleApplyVoucher,
  loading,
}) => (
  <PyroForm
    initialValues={initialValues}
    onSubmit={(values) => handleApplyVoucher(values.voucher)}
    onValidate={handleValidate}
  >
    {({ handleChange, hasErrors }) => (
      <Form>
        <Flex flexDirection="column" verticalSpacing="dense">
          <TextField
            name="voucher"
            label={<Localized id="voucher-code" />}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon
                    icon={Icons.CLOSE}
                    onClick={() => {
                      handleChange('voucher', '')
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <Button variant="secondary" type="submit" disabled={loading || hasErrors}>
            <Localized id="apply-voucher" />
          </Button>
        </Flex>
      </Form>
    )}
  </PyroForm>
)

export default VoucherSelectionActive
